export const TEXT_DEFAULT = {
  CHECKBOX_TEXT:
    'Ich bestätige hiermit, dass ich bei dem Termin mit dem Makler an der oben genannten Adresse persönlich anwesend sein werde.',
  CHECKBOX_TEXT_CALL:
    'Ich bestätige hiermit, dass ich an dem ausgewählten Termin telefonisch erreichbar sein werde.',
  CTA_TEXT: 'Termin vereinbaren',
  PHONE_ERROR_MSG: 'Ungültige Nummer. Bitte überprüfen Sie Ihre Eingabe.',
  ADDRESS_LABEL: 'Adresse',
  STREET_LABEL: 'Straße',
  NUMBER_LABEL: 'Hausnummer',
  ADDRESS_ERRORS: {
    default: 'Die angegebene Adresse ist ungültig. Bitte geben Sie eine gültige Adresse ein.',
    street: 'Straßenname fehlt. Bitte geben Sie einen gültigen Straßennamen ein.',
    number: 'Hausnummer fehlt. Bitte geben Sie eine gültige Hausnummer ein.',
    postalCode:
      'Die eingegebene Postleitzahl stimmt nicht mit der zuvor ausgewählten überein. Bitte geben Sie die gleiche Postleitzahl ein.',
  },
};
